import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/app/(site)/_components/pages/service/how-we-work/HowWeWorkSlider.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/app/(site)/_components/pages/service/service-page-slider/ServicePageSlider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/app/(site)/_components/pages/service/what-to-know-about-us/Accordion.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/app/(site)/_components/utils/hero-btn/HeroBtn.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/app/(site)/_components/utils/hero-text-animations/HeroTextAnimations.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/app/(site)/_components/utils/testimonial/TestimonialSlider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/node_modules/@sanity/next-loader/dist/client-components/live-stream.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/node_modules/@sanity/next-loader/dist/client-components/live.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/node_modules/next-sanity/dist/visual-editing/client-component.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/image-component.js");
